module.exports = __webpack_public_path__ + "static/media/brake-repair.cc897a77.svg";